export const orderSummaryOrderDetailProps = () => ({
  panierBySections: {
    type: Array,
    required: true
  },
  nbProduits: {
    type: Number,
    required: false,
    default: 0
  },
  avantagesCalcules: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const useOrderSummaryOrderDetail = () => {
  const nbArticlesBySection = (section) => {
    return section.articles.reduce(function (a, b) { return a + b.quantite; }, 0)
  }
  return { nbArticlesBySection }
}